import { useDispatch, useSelector } from 'react-redux';
import './css/app.css'
import './css/common.css'
import { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { change_Current_Location, changeHeaderTitle } from '../store';
import axios from 'axios';
import { MessageModal } from './component/modal/modal';
import bank from './bankList'

import { CountAmountLeft } from './component/btn/btn';
import List from './component/list/list';
import { LoadingModal } from './component/modal/modal';

import { SearchCrteateBtn } from './component/search/search';
import { Link, useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { ChevronRight, Asterisk } from 'lucide-react';

import useWindowSize from './hook/useWindowSize'

function CreateMerchantsAgent() {
    let dispatch = useDispatch();
    let navigate = useNavigate();
    const hostLogoImg = useSelector((state) => state.hostLogoImg.value);

    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState("");
    const [modal, setModal] = useState(false);

    useEffect(() => {
        dispatch(change_Current_Location("가맹점 등록"));
        dispatch(
            changeHeaderTitle({
                mainTitle: "가맹점 등록",
            })
        );

        setTimeout(() => {
            setLoading(false);
        }, 500);
    }, [dispatch]);

    const ResponsiveImage = ({ smallSrc, largeSrc, alt, breakpoint = 1280 }) => {
        const [windowWidth, setWindowWidth] = useState(window.innerWidth);

        useEffect(() => {
            const handleResize = () => setWindowWidth(window.innerWidth);
            window.addEventListener('resize', handleResize);
            return () => window.removeEventListener('resize', handleResize);
        }, []);

        const imageSrc = windowWidth <= breakpoint ? smallSrc : largeSrc;

        return <img src={imageSrc} alt={alt} className={windowWidth <= breakpoint ? "w-8" : "w-32"} />;
    };

    return (
        <div className="content" id="contents" style={{ width: "100%", height: "calc(100dvh - 57px)", background: "#fff" }}>
            {loading ? <LoadingModal /> : null}
            <div className={`mobile-menu md:hidden`}>
                <div className="mobile-menu-bar">
                    <Link to={`/`} className="main_logo flex mr-auto gnb-link">
                        {
                            hostLogoImg == "onu"
                                ?
                                <ResponsiveImage
                                    smallSrc="/img/ong.jpg"
                                    largeSrc="/img/ong.jpg"
                                    alt="East Commerce Logo"
                                    breakpoint={768}
                                />
                                :
                                <ResponsiveImage
                                    smallSrc="/img/dl_symbol.png"
                                    largeSrc="/img/dl_logo_white.png"
                                    alt="East Commerce Logo"
                                    breakpoint={1280}
                                />
                        }
                    </Link>
                </div>
            </div>
            <div className="top-bar-boxed h-[70px] md:h-[65px] z-[51] border-b border-white/[0.08] mt-12 md:mt-0 -mx-3 sm:-mx-8 md:-mx-0 px-3 md:border-b-0 relative md:fixed md:inset-x-0 md:top-0 md:px-8 md:bg-gradient-to-b md:from-slate-100 md:to-transparent dark:md:from-darkmode-700" style={{ maxWidth: "1920px", margin: "0 auto" }}>
                <div className="h-full flex items-center -intro-x h-[45px]" style={{ float: "left" }}>
                    <Link to={`/paylist`} className="main_logo flex mr-auto gnb-link">
                        {
                            hostLogoImg == "onu"
                                ?
                                <ResponsiveImage
                                    smallSrc="/img/ong.jpg"
                                    largeSrc="/img/ong.jpg"
                                    alt="East Commerce Logo"
                                    breakpoint={768}
                                />
                                :
                                <ResponsiveImage
                                    smallSrc="/img/dl_symbol.png"
                                    largeSrc="/img/dl_logo_white.png"
                                    alt="East Commerce Logo"
                                    breakpoint={1280}
                                />
                        }
                    </Link>
                </div>
            </div>
            <CreateInfo
                setModal={setModal}
                setMessage={setMessage}
            />
            <MessageModal message={message} />
        </div>
    );
}

function CreateInfo({ setModal, setMessage }) {
    const { Rwidth, Rheight } = useWindowSize();
    const [count, setCount] = useState(0);
    const heightRef = useRef();
    const [divHeight, setDivHeight] = useState(0);
    const [isSubmitting, setIsSubmitting] = useState(false);

    // ========== formData ==========  
    // 결제방식을 배열([])로 바꿨습니다.
    const initialFormData = {
        // 1. 사업자 정보 탭
        사업자구분: "비사업자",
        사업자명: "",
        사업자등록번호: "",
        주민등록번호: "",
        대표자명: "",
        업종: "",
        대표자연락처: "",
        사업자이메일: "",
        사업장주소: "",
        영업자ID: "",

        // 2. 계약 정보 탭
        정산은행: "",
        예금주: "",
        계좌번호: "",
        결제방식: [], // 배열로 변경
        수수료: "",

        // 3. 업로드 정보 탭 (배열)
        사업자등록증: [],
        통장사본: [],
        신분증앞면: [],
        신분증뒷면: [],
        사업장사진: [],
    };

    const [formData, setFormData] = useState(initialFormData);
    const [previewImage, setPreviewImage] = useState(null);

    // ==============================
    // (A) input/select 변화 처리
    // ==============================
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        // (1) "결제방식" 체크박스 배열
        if (name === "결제방식" && type === "checkbox") {
            setFormData((prev) => {
                const oldArr = prev.결제방식 || [];
                let newArr = [];
                if (checked) {
                    // 체크 ON → 배열에 추가
                    newArr = [...oldArr, value];
                } else {
                    // 체크 OFF → 배열에서 제거
                    newArr = oldArr.filter((v) => v !== value);
                }
                return { ...prev, 결제방식: newArr };
            });
            return;
        }

        // (2) 일반 input/select
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    // ==============================
    // (B) 파일 업로드 로직 (다중/단일)
    // ==============================
    const handleFileUpload = (e, fieldName) => {
        const files = Array.from(e.target.files);
        if (!files.length) return;

        setFormData((prev) => {
            const updatedList = [...prev[fieldName]];

            // ─────────────────────────────────────
            //  5개 제한: "사업장사진"일 때만 체크
            // ─────────────────────────────────────
            if (fieldName === "사업장사진") {
                const totalAfterUpload = updatedList.length + files.length;
                if (totalAfterUpload > 5) {
                    // 메시지 모달로 안내
                    setMessage({ msg: "사업장 사진은 최대 5개까지 업로드할 수 있습니다." });
                    return prev; // 기존 State 유지 (파일 추가되지 않음)
                }
            }

            // (기존 로직: 파일 목록에 push)
            files.forEach((file) => {
                const previewURL = URL.createObjectURL(file);
                updatedList.push({ file, previewURL });
            });

            return { ...prev, [fieldName]: updatedList };
        });
    };

    // 개별 이미지 삭제
    const handleDeleteImage = (fieldName, idx) => {
        setFormData((prev) => {
            const updatedList = [...prev[fieldName]];
            updatedList.splice(idx, 1);
            return { ...prev, [fieldName]: updatedList };
        });
    };

    // 큰 이미지 미리보기
    const handlePreviewClick = (previewURL) => {
        setPreviewImage(previewURL);
    };

    // ==============================
    // (C) 등록 (서버 전송)
    // ==============================
    const onSubmit = async () => {
        if (isSubmitting) return;
        if (formData.사업자구분.length == 0 || formData.사업자명.length == 0 || formData.대표자명.length == 0 || formData.대표자연락처.length == 0 ) {
            setMessage({ msg: "필수값이 입력되지 않았습니다." });
            return;
        }
        setIsSubmitting(true);

        try {
            const fd = new FormData();

            // 문자열/숫자 필드
            fd.append("businessType", formData.사업자구분);
            fd.append("businessName", formData.사업자명);
            fd.append("ownerName", formData.대표자명);
            fd.append("ownerPhone", formData.대표자연락처);
            fd.append("salesman", formData.영업자ID);
            fd.append("businessAddress", formData.사업장주소);
            fd.append("settleBank", formData.정산은행);
            fd.append("accountHolder", formData.예금주);
            fd.append("accountNumber", formData.계좌번호);

            // fd.append("payment_method", formData.결제방식.join(",")); // 예: "단말기,수기"

            // 파일(이미지) 필드
            formData.사업자등록증.forEach((item) => fd.append("businessLicense", item.file));
            formData.통장사본.forEach((item) => fd.append("bankbook", item.file));
            formData.신분증앞면.forEach((item) => fd.append("idCardFront", item.file));

            const response = await axios.post(process.env.REACT_APP_API + "/api/regist/franchise-application", fd, {
                withCredentials: true,
                // headers: { "Content-Type": "multipart/form-data" },
            });

            const tmp = response?.data;
            if (tmp?.code < 2000) {
                setMessage({ msg: "가맹점 신청에 성공했습니다." });
                setFormData(initialFormData);
                setModal(false)
            } else {
                setMessage({ msg: tmp?.msg ?? "가맹점 신청에 실패했습니다." });
            }
        } catch (error) {
            console.error(error);
            setMessage({ msg: "가맹점 신청 중 오류가 발생했습니다." });
        } finally {
            setIsSubmitting(false);
        }
    };

    // (D) 취소 → 폼 초기화
    const handleCancel = () => {
        setFormData(initialFormData);
    };

    // (E) 탭 스텝 UI
    const renderStepIndicator = () => {
        const getCircleStyle = (stepIndex) => {
            const isCompleted = stepIndex <= count;
            return {
                width: "28px",
                height: "28px",
                borderRadius: "50%",
                lineHeight: "28px",
                textAlign: "center",
                backgroundColor: isCompleted ? "#4caf50" : "#bbb",
                color: "#fff",
                margin: "0 auto 5px",
            };
        };

        return (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", margin: "1rem 0" }}>
                {/* Step 1 */}
                <div style={{ textAlign: "center" }}>
                    <div style={getCircleStyle(0)}>1</div>
                    <div style={{ fontSize: "12px" }}>기본정보</div>
                </div>

                <ChevronRight style={{ margin: "0 10px", color: "rgb(187, 187, 187)" }} />

                {/* Step 2 */}
                <div style={{ textAlign: "center" }}>
                    <div style={getCircleStyle(1)}>2</div>
                    <div style={{ fontSize: "12px" }}>계좌정보</div>
                </div>

                <ChevronRight style={{ margin: "0 10px", color: "rgb(187, 187, 187)" }} />

                {/* Step 3 */}
                <div style={{ textAlign: "center" }}>
                    <div style={getCircleStyle(2)}>3</div>
                    <div style={{ fontSize: "12px" }}>증빙서류</div>
                </div>
            </div>
        );
    };

    // (F) 높이 조절
    useEffect(() => {
        if (heightRef?.current?.clientHeight) {
            setDivHeight(heightRef.current.clientHeight + 1);
        }
    }, [heightRef, formData.사업자구분]);

    return (
        <>
            <div id="receipt-modal" className="modal" tabIndex="-1" style={{ background: "#fff", position: "absolute", zIndex: "0" }}>
                <div
                    className="modal-dialog"
                    style={{ padding: Rwidth > 767 ? "2rem" : "1rem .75rem", maxWidth: "500px", border: "1px solid #e9e9e9" }}
                >
                    {/* 모달 헤더 */}
                    <div className="modal-header receipt-modal-header" style={{ border: "none", padding: "0", marginBottom: "5px" }}>
                        <h2 className="font-medium text-base mr-auto modal_title_sty">가맹점 신청</h2>
                    </div>

                    {/* 단계 표시 */}
                    {renderStepIndicator()}

                    {/* 모달 바디 */}
                    <div
                        style={{
                            padding: "0",
                            maxHeight: "calc(100dvh - 300px)",
                            height: `${divHeight}px`,
                            overflowY: "auto",
                            fontSize: "12px",
                            display: "flex",
                            gap: "20px",
                        }}
                    >
                        <div className="list-info-box" style={{ width: "100%" }}>
                            <div className="box-gap">
                                <div className="gap" style={{ borderTop: "1px solid #e1e1e1" }}>
                                    {/* ===================== [탭1] 사업자 정보 ===================== */}
                                    {count === 0 ? (
                                        <ul ref={heightRef}>
                                            <li>
                                                <span className="left-text" style={{ width: "120px", height: "36px" }}>
                                                    사업자 구분<Asterisk size={10} style={{ color: "red" }} />
                                                </span>
                                                <select
                                                    name="사업자구분"
                                                    className="right-text"
                                                    style={{
                                                        width: "calc(100% - 122px)",
                                                        border: "none",
                                                        outline: "none",
                                                    }}
                                                    value={formData.사업자구분}
                                                    onChange={handleChange}
                                                >
                                                    <option value="비사업자">비사업자</option>
                                                    <option value="사업자">사업자</option>
                                                </select>
                                            </li>
                                            <li>
                                                <span className="left-text" style={{ width: "120px", height: "36px" }}>
                                                    {formData.사업자구분 === "사업자" ? "사업자명" : "상호명"}<Asterisk size={10} style={{ color: "red" }} />
                                                </span>
                                                <input
                                                    name="사업자명"
                                                    type="text"
                                                    className="right-text"
                                                    style={{
                                                        width: "calc(100% - 122px)",
                                                        border: "none",
                                                        outline: "none",
                                                    }}
                                                    value={formData.사업자명}
                                                    onChange={handleChange}
                                                />
                                            </li>
                                            {/* {formData.사업자구분 === "사업자" ? (
                                                <li>
                                                    <span className="left-text" style={{ width: "120px", height: "36px" }}>
                                                        사업자등록번호
                                                    </span>
                                                    <input
                                                        name="사업자등록번호"
                                                        type="text"
                                                        className="right-text"
                                                        style={{
                                                            width: "calc(100% - 122px)",
                                                            border: "none",
                                                            outline: "none",
                                                        }}
                                                        value={formData.사업자등록번호}
                                                        onChange={handleChange}
                                                    />
                                                </li>
                                            ) : (
                                                <li>
                                                    <span className="left-text" style={{ width: "120px", height: "36px" }}>
                                                        주민등록번호
                                                    </span>
                                                    <input
                                                        name="주민등록번호"
                                                        type="text"
                                                        className="right-text"
                                                        style={{
                                                            width: "calc(100% - 122px)",
                                                            border: "none",
                                                            outline: "none",
                                                        }}
                                                        value={formData.주민등록번호}
                                                        onChange={handleChange}
                                                    />
                                                </li>
                                            )} */}
                                            <li>
                                                <span className="left-text" style={{ width: "120px", height: "36px" }}>
                                                    대표자명<Asterisk size={10} style={{ color: "red" }} />
                                                </span>
                                                <input
                                                    name="대표자명"
                                                    type="text"
                                                    className="right-text"
                                                    style={{
                                                        width: "calc(100% - 122px)",
                                                        border: "none",
                                                        outline: "none",
                                                    }}
                                                    value={formData.대표자명}
                                                    onChange={handleChange}
                                                />
                                            </li>
                                            <li>
                                                <span className="left-text" style={{ width: "120px", height: "36px" }}>
                                                    대표자연락처<Asterisk size={10} style={{ color: "red" }} />
                                                </span>
                                                <input
                                                    name="대표자연락처"
                                                    type="text"
                                                    className="right-text"
                                                    style={{
                                                        width: "calc(100% - 122px)",
                                                        border: "none",
                                                        outline: "none",
                                                    }}
                                                    value={formData.대표자연락처}
                                                    onChange={handleChange}
                                                />
                                            </li>
                                            <li>
                                                <span className="left-text" style={{ width: "120px", height: "36px" }}>
                                                    영업자 ID
                                                </span>
                                                <input
                                                    name="영업자ID"
                                                    type="text"
                                                    className="right-text"
                                                    style={{
                                                        width: "calc(100% - 122px)",
                                                        border: "none",
                                                        outline: "none",
                                                    }}
                                                    value={formData.영업자ID}
                                                    onChange={handleChange}
                                                />
                                            </li>
                                            <li>
                                                <span className="left-text" style={{ width: "120px", height: "36px" }}>
                                                    사업장주소
                                                </span>
                                                <input
                                                    name="사업장주소"
                                                    type="text"
                                                    className="right-text"
                                                    style={{
                                                        width: "calc(100% - 122px)",
                                                        border: "none",
                                                        outline: "none",
                                                    }}
                                                    value={formData.사업장주소}
                                                    onChange={handleChange}
                                                />
                                            </li>
                                        </ul>
                                    ) : count === 1 ? (
                                        // ===================== [탭2] 계약 정보 =====================
                                        <ul>
                                            <li>
                                                <span className="left-text" style={{ width: "120px", height: "36px" }}>
                                                    정산은행
                                                </span>
                                                <select
                                                    name="정산은행"
                                                    className="right-text"
                                                    style={{
                                                        width: "calc(100% - 122px)",
                                                        border: "none",
                                                        outline: "none",
                                                    }}
                                                    value={formData.정산은행}
                                                    onChange={handleChange}
                                                >
                                                    {bank.map((item, i) => (
                                                        <option key={i} value={item.name}>
                                                            {item.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </li>
                                            <li>
                                                <span className="left-text" style={{ width: "120px", height: "36px" }}>
                                                    예금주
                                                </span>
                                                <input
                                                    name="예금주"
                                                    type="text"
                                                    className="right-text"
                                                    style={{
                                                        width: "calc(100% - 122px)",
                                                        border: "none",
                                                        outline: "none",
                                                    }}
                                                    value={formData.예금주}
                                                    onChange={handleChange}
                                                />
                                            </li>
                                            <li>
                                                <span className="left-text" style={{ width: "120px", height: "36px" }}>
                                                    계좌번호
                                                </span>
                                                <input
                                                    name="계좌번호"
                                                    type="text"
                                                    className="right-text"
                                                    style={{
                                                        width: "calc(100% - 122px)",
                                                        border: "none",
                                                        outline: "none",
                                                    }}
                                                    value={formData.계좌번호}
                                                    onChange={handleChange}
                                                />
                                            </li>

                                            {/* <li>
                                                <span className="left-text" style={{ width: "120px", height: "36px" }}>
                                                    결제방식
                                                </span>
                                                <div
                                                    className="right-text"
                                                    style={{
                                                        width: "calc(100% - 122px)",
                                                        border: "none",
                                                        outline: "none",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: "10px",
                                                    }}
                                                >
                                                    <label style={{ cursor: "pointer" }}>
                                                        <input
                                                            type="checkbox"
                                                            name="결제방식"
                                                            value="단말기"
                                                            checked={formData.결제방식.includes("단말기")}
                                                            onChange={handleChange}
                                                            style={{
                                                                marginRight: "4px",
                                                                width: "14px",
                                                                height: "14px",
                                                            }}
                                                        />
                                                        단말기
                                                    </label>
                                                    <label style={{ cursor: "pointer" }}>
                                                        <input
                                                            type="checkbox"
                                                            name="결제방식"
                                                            value="수기"
                                                            checked={formData.결제방식.includes("수기")}
                                                            onChange={handleChange}
                                                            style={{
                                                                marginRight: "4px",
                                                                width: "14px",
                                                                height: "14px",
                                                            }}
                                                        />
                                                        수기
                                                    </label>
                                                </div>
                                            </li> */}

                                            {/* <li>
                                                <span className="left-text" style={{ width: "120px", height: "36px" }}>
                                                    수수료
                                                </span>
                                                <input
                                                    name="수수료"
                                                    type="text"
                                                    className="right-text"
                                                    style={{
                                                        width: "calc(100% - 122px)",
                                                        border: "none",
                                                        outline: "none",
                                                    }}
                                                    value={formData.수수료}
                                                    onChange={handleChange}
                                                />
                                            </li> */}
                                        </ul>
                                    ) : (
                                        // ===================== [탭3] 업로드 정보 =====================
                                        <ul>
                                            {formData.사업자구분 === "사업자"
                                                ?
                                                <UploadListItem
                                                    fieldName="사업자등록증"
                                                    label="사업자등록증"
                                                    formData={formData}
                                                    setFormData={setFormData}
                                                    handleFileUpload={handleFileUpload}
                                                    handleDeleteImage={handleDeleteImage}
                                                    handlePreviewClick={handlePreviewClick}
                                                />
                                                :
                                                ""
                                            }

                                            <UploadListItem
                                                fieldName="통장사본"
                                                label="통장사본"
                                                formData={formData}
                                                setFormData={setFormData}
                                                handleFileUpload={handleFileUpload}
                                                handleDeleteImage={handleDeleteImage}
                                                handlePreviewClick={handlePreviewClick}
                                            />

                                            <UploadListItem
                                                fieldName="신분증앞면"
                                                label="신분증 앞면"
                                                formData={formData}
                                                setFormData={setFormData}
                                                handleFileUpload={handleFileUpload}
                                                handleDeleteImage={handleDeleteImage}
                                                handlePreviewClick={handlePreviewClick}
                                            />

                                            {/* <UploadListItem
                                                fieldName="신분증뒷면"
                                                label="신분증 뒷면"
                                                formData={formData}
                                                setFormData={setFormData}
                                                handleFileUpload={handleFileUpload}
                                                handleDeleteImage={handleDeleteImage}
                                                handlePreviewClick={handlePreviewClick}
                                            /> */}

                                            <UploadListItem
                                                fieldName="사업장사진"
                                                label="사업장 사진"
                                                formData={formData}
                                                setFormData={setFormData}
                                                handleFileUpload={handleFileUpload}
                                                handleDeleteImage={handleDeleteImage}
                                                handlePreviewClick={handlePreviewClick}
                                            />
                                        </ul>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* 모달 푸터 */}
                    {count === 0 ? (
                        <div className="modal-footer" style={{ justifyContent: "space-between" }}>
                            {/* <button
                                type="button"
                                className="btn btn-primary w-20 close_btn"
                                onClick={() => setModal(false)}
                                style={{ backgroundColor: "darkred", border: "none" }}
                            >
                                취소
                            </button> */}
                            <div></div>
                            <button
                                type="submit"
                                className="btn btn-primary w-20 reg_btn"
                                onClick={() => setCount((e) => e + 1)}
                            >
                                다음
                            </button>
                        </div>
                    ) : count === 1 ? (
                        <div className="modal-footer" style={{ justifyContent: "space-between" }}>
                            <button
                                type="submit"
                                className="btn btn-primary w-20 reg_btn"
                                onClick={() => setCount((e) => e - 1)}
                            >
                                이전
                            </button>
                            <button
                                type="submit"
                                className="btn btn-primary w-20 reg_btn"
                                onClick={() => setCount((e) => e + 1)}
                            >
                                다음
                            </button>
                        </div>
                    ) : (
                        <div className="modal-footer" style={{ justifyContent: "space-between" }}>
                            <button
                                type="submit"
                                className="btn btn-primary w-20 reg_btn"
                                onClick={() => setCount((e) => e - 1)}
                            >
                                이전
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary w-20 close_btn"
                                onClick={onSubmit}
                                style={{ backgroundColor: "#1e008f", marginLeft: "10px", border: "none" }}
                                disabled={isSubmitting}
                            >
                                신청
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}

function UploadListItem({
    fieldName,
    label,
    formData,
    handleFileUpload,
    handlePreviewClick,
    handleDeleteImage,
}) {
    // DOM 참조 ref (높이 측정용)
    const containerRef = useRef(null);
    // <input type="file"> 참조 (파일 초기화 위해)
    const inputRef = useRef(null);

    // 실제 DOM 높이
    const [containerHeight, setContainerHeight] = useState(0);

    // "사업장사진"이면 다중 업로드, 아니면 단일 업로드
    const isMultiple = fieldName === "사업장사진";

    // formData[fieldName]가 변경될 때마다 레이아웃 재측정
    useLayoutEffect(() => {
        if (containerRef.current) {
            setContainerHeight(containerRef.current.clientHeight);
        }

        // "모든 파일이 삭제"된 경우, inputRef.current.value를 ""로 만들어
        // "파일 없음" 상태로 복귀
        const arr = formData[fieldName] || [];
        if (arr.length === 0 && inputRef.current) {
            inputRef.current.value = "";
        }
    }, [formData[fieldName], fieldName]);

    // ─────────────────────────────────────────────
    // (1) 단일 업로드 (사업자등록증, 통장사본, 신분증앞면, 신분증뒷면)
    // ─────────────────────────────────────────────
    if (!isMultiple) {
        // 단일 파일(첫번째 아이템) 혹은 undefined
        const fileItem = formData[fieldName]?.[0];

        return (
            <li style={{ display: "flex", alignItems: "flex-start" }}>
                {/* 왼쪽 라벨 영역 */}
                <span
                    className="left-text"
                    style={{
                        width: "120px",
                        height: containerHeight ? `${containerHeight}px` : "auto",
                        lineHeight: "26px",
                        display: "inline-block",
                    }}
                >
                    {label}
                </span>

                {/* 우측 업로드 영역 */}
                <div ref={containerRef} style={{ flex: 1 }}>
                    {/* 파일 업로드 (단일) */}
                    <input
                        type="file"
                        accept="image/*"
                        ref={inputRef}
                        style={{
                            width: "calc(100% - 42px)",
                            border: "none",
                            outline: "none",
                            marginTop: "6px",
                            marginLeft: "6px",
                            marginBottom: "6px",
                        }}
                        onChange={(e) => handleFileUpload(e, fieldName)}
                    />

                    {/* 파일이 있으면 "삭제" 버튼 표시 */}
                    {fileItem && (
                        <button
                            type="button"
                            onClick={() => handleDeleteImage(fieldName, 0)}
                            style={{
                                background: "#999",
                                color: "#fff",
                                border: "none",
                                borderRadius: "4px",
                                fontSize: "12px",
                                padding: "3px 6px",
                                cursor: "pointer",
                            }}
                        >
                            삭제
                        </button>
                    )}
                </div>
            </li>
        );
    }

    // ─────────────────────────────────────────────
    // (2) 다중 업로드 (사업장사진)
    // ─────────────────────────────────────────────
    return (
        <li style={{ display: "flex", alignItems: "flex-start" }}>
            <span
                className="left-text"
                style={{
                    width: "120px",
                    height: containerHeight ? `${containerHeight}px` : "auto",
                    lineHeight: "26px",
                    display: "inline-block",
                }}
            >
                {label}
            </span>

            <div ref={containerRef} style={{ flex: 1 }}>
                {/* 파일 업로드 (다중) */}
                <input
                    type="file"
                    multiple
                    accept="image/*"
                    ref={inputRef}
                    style={{
                        width: "calc(100% - 8px)",
                        border: "none",
                        outline: "none",
                        marginTop: "6px",
                        marginLeft: "6px",
                    }}
                    onChange={(e) => handleFileUpload(e, fieldName)}
                />

                {/* 썸네일 목록 */}
                <div style={{ display: "flex", flexWrap: "wrap", marginTop: "6px" }}>
                    {(formData[fieldName] || []).map((item, idx) => (
                        <div
                            key={idx}
                            style={{
                                width: "50px",
                                height: "50px",
                                marginLeft: "8px",
                                marginBottom: "8px",
                                border: "1px solid #ddd",
                                borderRadius: "4px",
                                position: "relative",
                                overflow: "hidden",
                                cursor: "pointer",
                            }}
                        >
                            <img
                                src={item.previewURL}
                                alt="preview"
                                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                onClick={() => handlePreviewClick(item.previewURL)}
                            />
                            <button
                                type="button"
                                onClick={() => handleDeleteImage(fieldName, idx)}
                                style={{
                                    position: "absolute",
                                    top: "2px",
                                    right: "2px",
                                    background: "rgba(0,0,0,0.5)",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "2px",
                                    fontSize: "12px",
                                    cursor: "pointer",
                                    padding: "2px 4px",
                                }}
                            >
                                x
                            </button>
                        </div>
                    ))}
                </div>
            </div>
        </li>
    );
}

export default CreateMerchantsAgent;